import { AuthContextProps } from "../components/auth-context";
import {  postData } from "./core";

export default class NgnChannelApi {
  static uri = "a/internet/NgnChannel";
  context: AuthContextProps;
  constructor(context: AuthContextProps) {
    this.context = context;
  }
  post(
    fileId: number,
  ) {
    return postData({
      uri: NgnChannelApi.uri,
      data: {
       fileId,
      },
      context: this.context,
    });
  }
}
